// export function keys<O extends {}>(obj: O): (keyof O)[] {
//   return Object.keys(obj) as (keyof O)[];
// }
export function keys<O extends {}>(
  obj: O
): (O extends any ? keyof O : never)[] {
  return Object.keys(obj) as (O extends any ? keyof O : never)[];
}

// export function entries<O extends {}>(obj: O): [keyof O, O[keyof O]][] {
//   return Object.entries(obj) as [keyof O, O[keyof O]][];
// }
// export function entries<O extends {}>(
//   obj: O
// ): [O extends any ? keyof O : never, O extends any ? O[keyof O] : never][] {
//   return Object.entries(obj) as [
//     O extends any ? keyof O : never,
//     O extends any ? O[keyof O] : never
//   ][];
// }
export function entries<O extends {}>(
  obj: O
): Exclude<
  O extends any ? { [K in keyof O]: [K, O[K]] }[keyof O] : never,
  undefined
>[] {
  return Object.entries(obj) as Exclude<
    O extends any ? { [K in keyof O]: [K, O[K]] }[keyof O] : never,
    undefined
  >[];
}

export function filterEntries<O extends {}>(
  obj: O,
  condition: (v: [keyof O, O[keyof O]]) => boolean
): O {
  return Object.fromEntries(
    (Object.entries(obj) as [keyof O, O[keyof O]][]).filter(condition)
  ) as O;
}

export function updateEntries<O extends {}>(
  obj: O,
  updater: (v: [keyof O, O[keyof O]]) => [keyof O, O[keyof O]]
): O {
  return Object.fromEntries(
    (Object.entries(obj) as [keyof O, O[keyof O]][]).map(updater)
  ) as O;
}

export function mapEntries<O extends {}, Out extends {}>(
  obj: O,
  updater: (v: [keyof O, O[keyof O]]) => [keyof Out, Out[keyof Out]]
): Out {
  return Object.fromEntries(
    (Object.entries(obj) as [keyof O, O[keyof O]][]).map(updater)
  ) as Out;
}

// Test

type Obj = { a: 1; b: "s"; c: true };

type Old = [keyof Obj, Obj[keyof Obj]];
type New = EntryOf<Obj>;

type EntryMapOf<O extends {}> = {
  [Key in keyof O]: [Key, O[Key]];
};

export type EntryOf<O extends {}> = Exclude<
  {
    [Key in keyof O]: [Key, O[Key]];
  }[keyof O],
  undefined
>;

// type test = EntryOf<TLayoutNodeUnion["propInputControls"]>;

// type a = TLayoutNodeUnion["propInputControls"];

type b = keyof ({} | Obj);
